import { cn } from "@repo/shared/utils";
import { Calendar } from "@repo/ui/components/Base/Calendar";
import { useState } from "react";

export const ReoccurrencePreview = ({
  occurrences,
}: {
  occurrences: Date[];
}) => {
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [pickedDate, setPickedDate] = useState(new Date(0));

  return (
    <div className="w-full rounded-md bg-gray-200 flex flex-row items-stretch">
      <div className="grow relative">
        <div className="absolute inset-0 overflow-y-scroll px-4 py-3">
          <ul className="py-2">
            {occurrences.map((date, i) => (
              <li
                key={i}
                className={cn(
                  "px-1 py-0.5 rounded-md cursor-pointer hover:bg-slate-100",
                  date.getTime() === pickedDate.getTime() && "bg-slate-300"
                )}
                onClick={() => {
                  setCalendarMonth(date);
                  setPickedDate(date);
                }}
              >
                {date.toDateString()}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Calendar
        className="bg-white"
        mode="multiple"
        selected={occurrences}
        onSelect={() => {
          /* required to make the component 'controlled' */
        }}
        onMonthChange={(month) => setCalendarMonth(month)}
        month={calendarMonth}
        onDayClick={(date) => setPickedDate(date)}
      />
    </div>
  );
};
